<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col.my-header.font-weight-bold
        | Маркетплейс

  .container.services
    .row
      .col-sm-4.service(
        v-for="service in services",
        :class="{ subscribed: service.subscribed }"
      )
        .white_block(
          :style="{ 'background-image': `url(/assets/services/bg/${service.id}.png)` }"
        )
          .subscribed_label Подключено
          .name {{ service.name }}
            .free.free_label(
              v-if="service.day_price == 0 && service.soon != 1"
            ) Бесплатно
            .soon.soon_label(v-if="service.soon == 1") Скоро
          .description(v-html="service.description")
          .price 
            span(v-if="service.special_price == undefined") {{ service.day_price ? 'Обслуживание ' + service.day_price + ' ' + default_currency + '/дн.' : 'Бесплатное обслуживание.' }}
            span(v-if="service.special_price != undefined") {{ service.special_price ? 'Только для Вас: обслуживание за ' + service.special_price + ' ' + default_currency + '/дн.' : 'Только для Вас: бесплатно.' }}
            br
            | {{ service.also_payments ? service.also_payments : 'полный пакет' }}
          .buttons
            //- button.ask(@click="open_chat(service.name)") Есть вопрос
            button.styled.disable(
              v-if="service.subscribed",
              @click="unsubscribe(service)",
              :class="{ loading: service.loading }",
              :disabled="service.loading"
            ) 
              .spinner-border.spinner-border-sm(role="status")
                span.sr-only Loading...
              | Отключить
            button.styled.enable(
              v-else,
              @click="subscribe(service)",
              :class="{ loading: service.loading }",
              :disabled="service.loading || service.soon == 1"
            )
              .spinner-border.spinner-border-sm(role="status")
                span.sr-only Loading...
              | Подключить

  modal(name="we_need_pos_auth", height="auto") 
    .container
      .row
        .col
          h2 Один момент...
          .content
            | Для подключения этого сервиса требуется
            b интеграция в Вашу систему учёта.
            br
            br
            | Пожалуйста, пройдите шаги интеграции, чтобы мы смогли взаимодействовать непосредственно с Вашей системой.
            .buttons
              router-link.styled.go_connect(to="account/new_pos_auth") Начать интеграцию
</template>
<script>
var apiDriver = require("../apiDriver").default;
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  components: {},

  data() {
    return {
      default_currency: "руб.",
      default_bonus_currency: "бон.",

      test: true,
      services: [],
      subscriptons: [],
    };
  },

  computed: {},

  mounted() {
    this.loadServices();
  },

  methods: {
    open_chat(service_name) {
      // jivo_api.open();
      window.ChatConnect.chatStorage.main_account_chat.openChat(
        "Здравствуйте, у меня вопрос по сервису " + service_name + ".\n"
      );
    },

    async loadServices() {
      var subscriptons = await apiDriver.subscriptions.list();
      this.subscriptons = subscriptons;
      var services = (await apiDriver.services.list()).list;
      services = services.filter((x) => x.hide != 1);
      services.sort((x, y) => x.market_sorting - y.market_sorting);

      this.services = [];
      for (var service of services) {
        var x = service;
        let subscribed = subscriptons.find((i) => i.service_id == service.id);
        if (subscribed) {
          x.subscribed = true;
          if (subscribed.day_price != service.day_price)
            x.special_price = subscribed.day_price;
        }
        x.loading = false;
        this.services.push(x);
      }
      console.log("services->", this.services);
    },

    async unsubscribe(service) {
      service.loading = true;
      console.log("unsubscribe service_id:", service.id);
      await apiDriver.subscriptions.remove(service.id);
      await this.$store.dispatch("updateUserData");
      this.loadServices();
      this.$toast.info("Вы отписались от сервиса " + service.name + "!");
      this.$forceUpdate();
      // document.location.reload();
    },

    async subscribe(service) {
      service.loading = true;
      var check = await checkServiceForRequirement(service.id);
      if (check.accepted) {
        await apiDriver.subscriptions.add(service.id);
        await this.$store.dispatch("updateUserData");
        this.loadServices();
        this.$toast.info("Сервис " + service.name + " успешно подключен!");
        this.$forceUpdate();
        // document.location.reload();
      } else {
        // берем первый первый же запрет из всех и говорим о нем пользователю
        var first_disallowed = check.disallowed[0];
        service.loading = false;

        switch (first_disallowed) {
          case "pos_auth":
            this.$modal.show("we_need_pos_auth");

            break;
          case "contract":
            swal({
              title: "Ждём договора",
              text: "Для того чтобы подключить сервис, Вам необходимо подписать с нами договор.",
              type: "info",
            });
            break;

          default:
            break;
        }
      }
    },
  },
};

/**
 * Получение front-end разрешения на подключение заведения
 */
async function checkServiceForRequirement(service_id) {
  console.log("checkServiceForRequirement->", service_id);
  var services = (await apiDriver.services.list()).list;
  var connections = (await apiDriver.connections.list()).list;
  var contract_signed = (await apiDriver.documents.contract()).signed;
  var service = services.find((x) => x.id == service_id);
  var accepted_count = 0;
  var disallowed = [];
  for (var requirement of service.requirements) {
    switch (requirement) {
      case "contract":
        if (contract_signed) {
          accepted_count++;
        } else {
          disallowed.push(requirement);
        }
        break;
      case "pos_auth":
        if (connections.find((x) => x.type == "POS")) {
          accepted_count++;
        } else {
          disallowed.push(requirement);
        }
      default:
        break;
    }
    console.log("requirement:", requirement);
  }
  var accepted = accepted_count == service.requirements.length;
  return { accepted, disallowed };
}
</script>

<style scoped lang="stylus">
.my-header {
  font-size: 26pt;
}

button.styled, a.styled {
  .spinner-border {
    margin-right: 8px;
    display: none;
  }

  &.loading {
    .spinner-border {
      display: inline-block;
    }
  }
}

button.disable {
  color: gray;
  border-color: gray;

  &:hover {
    color: white !important;
    background: red !important;
    border-color: red !important;
  }
}

.services {
  margin-top: 20px;

  .service {
    margin-top: 20px;

    .subscribed_label {
      display: none;
    }

    .white_block {
      background-size: 150px !important;
      background-position: top right !important;
      background-repeat: no-repeat !important;
      position: relative;
    }

    .name {
      margin-bottom: 6px;
      font-size: 15pt;
      margin: 60px 0;

      .free_label {
        color: #9693d8;
        font-size: 10pt;
        position: relative;
        margin-top: -19px;
        top: 19px;
      }

      .soon_label {
        color: #ff5722;
        font-size: 10pt;
        position: relative;
        margin-top: -19px;
        top: 19px;
      }
    }

    .description {
      font-size: 10pt;
      margin-bottom: 10px;
      color: #3e3e3e;
      min-height: 150px;
    }

    .price {
      // margin-left: 110px;
      margin-bottom: 10px;
      font-size: 10pt;
      text-align: right;
      border-top: 1px solid #eee;
      padding-top: 5px;
    }

    .buttons {
      text-align: right;
      padding: 10px;
      padding-right: 0;

      .ask {
        text-decoration: underline;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        margin-right: 10px;
        opacity: 0.7;

        &:hover {
          opacity: 1;
        }
      }
    }

    &.subscribed {
      .subscribed_label {
        color: #4CAF50;
        border: 1px solid;
        display: inline-block;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 9pt;
        cursor: default;
        position: absolute;
        top: 15px;
        left: 15px;
      }
    }
  }
}

.v--modal-overlay {
  h2 {
    margin-top: 10px;
    color: #484848;
    margin-bottom: 10px;
  }

  .buttons {
    margin-top: 120px;
    text-align: right;
    margin-bottom: 24px;
  }
}

@media only screen and (max-width: 600px) {
  .services .service .price {
    margin-left: 0;
  }
}

@media (prefers-color-scheme: dark) {
  .services .service .description {
    color: white;
  }

  button.disable {
    color: #ffffff;
    border-color: #a9a9a9;
    background: #3d3b70;
  }
}
</style>